// Google Analytics 4 integration for EventAlly
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

// Initialize Google Analytics
export const initGA = () => {
  // Only initialize when ID is available
  if (!GA_MEASUREMENT_ID) {
    console.log('GA Measurement ID not provided, skipping analytics initialization');
    return;
  }

  try {
    // Add gtag script to head
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script1);

    // Initialize gtag
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${GA_MEASUREMENT_ID}', {
        send_page_view: false
      });
    `;
    document.head.appendChild(script2);

    // Set global gtag function
    window.dataLayer = window.dataLayer || [];
    window.gtag = function() { window.dataLayer.push(arguments); };
    
    console.log('Google Analytics initialized successfully');
  } catch (error) {
    console.error('Error initializing Google Analytics:', error);
  }
};

// Track page views
export const trackPageView = (path) => {
  if (!GA_MEASUREMENT_ID) return;
  
  try {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: path,
        page_title: document.title
      });
      console.log(`Page view tracked: ${path}`);
    }
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (!GA_MEASUREMENT_ID) return;
  
  try {
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', action, {
        event_category: category,
        event_label: label,
        value: value,
      });
      console.log(`Event tracked: ${action} - ${category} - ${label}`);
    }
  } catch (error) {
    console.error('Error tracking event:', error);
  }
};

// EventAlly specific event tracking functions
export const trackUserAction = (action, details = {}) => {
  trackEvent(action, 'user_action', details.label || action, details.value);
};

export const trackActivityInteraction = (action, activityId) => {
  trackEvent(action, 'activity', `activity_${activityId}`);
};

export const trackEventManagement = (action, eventType = 'private_event') => {
  trackEvent(action, 'event_management', eventType);
};

export const trackChatInteraction = (action, messageCount) => {
  trackEvent(action, 'chat', undefined, messageCount);
};